import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__onlineOfflineMode.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

export type OnlineOfflineMode = 'online' | 'offline'

const DeviceSettingsOnlineOfflineMode = (p_: {
    enabled: boolean
    value: OnlineOfflineMode | null
    className: string | object
    onChange: (value: OnlineOfflineMode, field: string) => void
}) => {
    if (!p_.enabled) {
        return null
    }

    const isOffline = p_.value === 'offline'

    return (
        <div className={cn(p_.className)}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={isOffline}
                    onChange={() => {
                        p_.onChange(isOffline ? 'online' : 'offline', 'onlineOfflineMode')
                    }}
                    className={`test-settings-toggle_${isOffline ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('waitContentDownloadBeforePlaying')}
                    </Typography>
                </div>
            </div>
        </div>
    )
}

DeviceSettingsOnlineOfflineMode.defaultProps = {
    value: 'online',
}

export default React.memo(DeviceSettingsOnlineOfflineMode)
